import { Mono } from '@jotpsych/ui';
import { Stack, Typography } from '@mui/material';

import type { ClaimWorkItem } from '../../../store';

import { type ClaimWorkPayerStatus, formatPayerStatusLine } from './payerStatusLine';

export type ClaimWorkOutcomeReason = NonNullable<ClaimWorkItem['outcome_reason']>;

export interface ReasonDetailProps {
  reason: ClaimWorkOutcomeReason;
  payerStatus?: ClaimWorkPayerStatus | null;
}

const LINE_SX = { fontSize: 'inherit', lineHeight: 'inherit' } as const;

/**
 * The Reason popover (GDN-3379): the category the payer's codes normalize
 * to as the heading, the codes one per line in mono, and the payer's last
 * word underneath. Codes only: the app carries no CARC/RARC description
 * dictionary, so there is nothing true to print beside them.
 */
export const ReasonDetail = ({ reason, payerStatus }: ReasonDetailProps) => {
  const codes = reason.codes ?? [];
  const payerLine = formatPayerStatusLine(payerStatus);
  return (
    <Stack spacing={0.75}>
      <Typography component="div" sx={{ ...LINE_SX, fontWeight: 600 }}>
        {reason.category ?? 'Reason codes'}
      </Typography>
      {codes.length > 0 && (
        <Stack component="ul" spacing={0.25} sx={{ listStyle: 'none', m: 0, p: 0 }}>
          {codes.map((code, index) => (
            <Mono component="li" key={`${code}-${index}`} sx={{ fontWeight: 500 }}>
              {code}
            </Mono>
          ))}
        </Stack>
      )}
      {payerLine && (
        <Typography color="text.secondary" component="div" sx={LINE_SX}>
          {payerLine}
        </Typography>
      )}
    </Stack>
  );
};
